// extracted by mini-css-extract-plugin
module.exports = {"bannerText":"MessageBanner_bannerText__hN8AQ"};